import Carousel from 'global/carousel.src';

(function ready(fn) {
    if (document.readyState != 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
})(function () {
    [].forEach.call(document.querySelectorAll('.carousel'), function (carousel) {
        var c = new Carousel(carousel);
    });
});
